<ng-container *ngIf="{
  requestCurrent: requestSystemCurrentEvent$ | async,
  requestHistorical: requestSystemHistoricalEvent$ | async,
  requestHistoricalPending: systemHistoricalEventPending$ | async,
} as resolver">
  <mat-tab-group id="mat-tab-group">
    <mat-tab [label]="labels.currentEventTitle">
      <div
        class="p-3"
        id="current-tab-grid">
        <lib-block-title
          id="current-event-title"
          [title]="labels.currentEventTitle">
        </lib-block-title>

        <azzurro-table
          id="system-current-event-table"
          [uiFramework]="'material'"
          [columns]="columns"
          [labels]="labels"
          [data$]="systemCurrentEvent$"
          [mode]="'client'"
          [pagination]="true"
          [paginationConfig]="defaultPaginationConfig"
          [noResultTemplate]="currentNoResult">
        </azzurro-table>
        <azzurro-table
          id="system-current-event-list"
          [uiFramework]="'ionic'"
          [columns]="columns"
          [labels]="labels"
          [data$]="systemCurrentEvent$"
          [mode]="'client'"
          [pagination]="true"
          [paginationConfig]="defaultPaginationConfig"
          [noResultTemplate]="currentNoResult">
        </azzurro-table>
      </div>
    </mat-tab>

    <mat-tab [label]="labels.historicalEventTitle">
      <div
        class="p-3"
        id="historical-tab-grid">
        <lib-block-title
          id="historical-event-title"
          [title]="labels.historicalEventTitle">
        </lib-block-title>

        <calendar-picker
          id="calendar-picker"
          startView="month"
          [disabled]="resolver.requestHistoricalPending || false"
          (dateSelected)="dateSelection$.next($event);">
        </calendar-picker>

        <azzurro-table
          id="system-historical-event-table"
          [uiFramework]="'material'"
          [columns]="historicalColumns"
          [labels]="labels"
          [data$]="systemHistoricalEvent$"
          [mode]="'client'"
          [pagination]="true"
          [paginationConfig]="defaultPaginationConfig"
          [noResultTemplate]="historyNoResult">
        </azzurro-table>
        <azzurro-table
          id="system-historical-event-list"
          [uiFramework]="'ionic'"
          [columns]="historicalColumns"
          [labels]="labels"
          [data$]="systemHistoricalEvent$"
          [mode]="'client'"
          [pagination]="true"
          [paginationConfig]="defaultPaginationConfig"
          [noResultTemplate]="historyNoResult">
        </azzurro-table>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-container>

<ng-template #historyNoResult>
  <div class="fx-col fx-center">
    <div class="tw-font-medium tw-text-base tw-text-grey-400">
      {{ labels.noResultsForSelectedPeriod }}
    </div>
  </div>
</ng-template>

<ng-template #currentNoResult>
  <div class="w-fit mx-auto px-6 border-green-200 bg-green-100 border-1 p-3 radius-4 tw-font-medium tw-text-base tw-text-grey-400">
    <mat-icon fontIcon="sentiment_very_satisfied"></mat-icon>
    <p class="fx-g-1"> {{ labels.noCurrentEvents }}</p>
  </div>
</ng-template>